module.exports = __webpack_public_path__ + "static/media/lingua-screenshot-4.72583759.png";